import Api from 'api'

const config = {
  baseURL: '/api/app/v1/promised-payments',
}
const api = new Api(config)

api.fetchAll = ({ ...rest }) => api.get('', { ...rest })

api.fetchSettings = () => api.get('/settings')

api.create = ({ ...rest }) => api.post('', { ...rest })

//@TODO remove if deprecated or unused
// api.calculateTotal = ({ ...rest }) =>
//   api.get('/promised-payment/calculate', { ...rest })

export default api
